import { connect } from 'react-redux';
import ValidatePassword from './ValidatePassword.jsx';
import { reAuthenticateUser } from '../../../redux/auth/actions';

const mapStateToProps = (state) => ({
  fetching: state.authReducer.fetching,
  changePasswordErrors: state.authReducer.changePasswordErrors,
});

const mapDispatchToProps = {
  reAuthenticateUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidatePassword);
